"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLogEntriesForLevel = getLogEntriesForLevel;
exports.maturityLevelToString = maturityLevelToString;
exports.dependencyTypeToString = dependencyTypeToString;
exports.checkForSuccess = checkForSuccess;
const types_1 = require("./types");
function getLogEntriesForLevel(logEntries, ...levels) {
    return logEntries.filter((entry) => levels.indexOf(entry.level) !== -1);
}
function maturityLevelToString(level) {
    switch (level) {
        case types_1.MaturityLevel.experimental:
            return "experimental";
        case types_1.MaturityLevel.preview:
            return "preview";
        case types_1.MaturityLevel.stable:
            return "stable";
        default:
            throw new Error("unknown level");
    }
}
function dependencyTypeToString(type) {
    switch (type) {
        case types_1.DependencyType.abstractions:
            return "abstractions";
        case types_1.DependencyType.serialization:
            return "serialization";
        case types_1.DependencyType.authentication:
            return "authentication";
        case types_1.DependencyType.http:
            return "http";
        case types_1.DependencyType.bundle:
            return "bundle";
        case types_1.DependencyType.additional:
            return "additional";
        default:
            throw new Error("unknown type");
    }
}
function checkForSuccess(results) {
    for (const result of results) {
        if (result && result.message) {
            if (result.message.includes("Generation completed successfully")) {
                return true;
            }
        }
    }
    return false;
}
//# sourceMappingURL=utils.js.map